import { DedicatedDevTeams } from '@rumblefish/web-next/views/dedicatedDevTeams/DedicatedDevTeams';
export default DedicatedDevTeams;
